import React from "react";

import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col } from "react-bootstrap";

import { NavLink } from "react-router-dom";

import { FaFacebookF, FaInstagram, FaPinterest, FaTwitter, FaYoutube, FaCheck, FaSketch, FaOpencart } from "react-icons/fa";
import { BsSendCheck, BsFill1CircleFill, BsFill2CircleFill, BsFill3CircleFill, BsFill4CircleFill, BsFill5CircleFill, BsCheckLg, BsFillPatchCheckFill, BsClipboardCheck } from "react-icons/bs";

function TermsOfService() {

    return (

        <Container>

            <br/>

            <h3><strong><BsClipboardCheck/> ข้อกำหนดการให้บริการ</strong></h3>
       
            <h3 className="pb-3 border-bottom"></h3>
            <br/>
            {/* <h4 style={{fontSize:80, color: 'black'}}>❝</h4> */}
            <p style={{marginTop: 5}}>โปรดอ่านทำความเข้าใจตามเงื่อนไขและข้อตกลงก่อนทำการลงทะเบียน หลังจากที่การลงทะเบียนเสร็จสมบูรณ์แล้วถือว่าท่านยอมรับเงื่อนไขและข้อตกลงระหว่างสมาชิกกับผู้ให้บริการ EduLaw ทั้งสองฝ่ายตกลงทำข้อตกลงกันดังมีข้อความดังต่อไปนี้</p>
            <p style={{marginTop: 5}}>หนังสืออิเล็กทรอนิกส์ (E-BOOK)</p>
            <p style={{marginTop: 5}}>(1) หนังสืออิเล็กทรอนิกส์ที่เผยแพร่ใน EduLaw จะถูกเข้ารหัสเพื่อจัดการลิขสิทธ์ (Digital Right Management)
                                    <br/>(2) สมาชิกสามารถ Authorize อุปกรณ์พกพาได้ โดยไม่จำจัด และ Apple Id/Google Account ต้องตรงกับอุปกรณ์ที่ซื้อหนังสือใน EduLaw นอกจากนั้น สมาชิกจะต้องใช้หนังสือเฉพาะแก่ตนเอง
                                    <br/>(3) หนังสืออิเล็กทรอนิกส์ และตัวอย่างหนังสืออิเล็กทรอนิกส์
                                    ที่ถูกจัดจำหน่ายโดย EduLaw ห้ามทำซ้ำ ดัดแปลง แก้ไข เผยแพร่ จัดจำหน่าย
                                    โดยไม่ได้รับอนุญาตจาก EduLaw</p>

            <p style={{marginTop: 5}}>บัญชีผู้ใช้งาน</p>
            <p style={{marginTop: 5}}>(1) ผู้ที่ต้องการสมัครสมาชิกต้องกรอกข้อมูลของตนเองที่เป็นจริงให้แก่ EduLaw ให้ครบทุกข้อ
                                    <br/>(2) ผู้ใดแอบอ้าง หรือกระทำการใดๆ อันเป็นการละเมิดสิทธิ์ส่วนบุคคลโดยใช้ข้อมูลของผู้อื่นมาแอบอ้างสมัครสมาชิกเพื่อให้ได้สิทธิ์การสมาชิก ถือเป็นความผิด ต้องรับโทษตามที่กฎหมายกำหนดไว้
                                    <br/>(3) เพื่อความเป็นส่วนตัวและความปลอดภัยในข้อมูลของท่านเอง EduLaw ขอแจ้งให้ทราบว่า เป็นหน้าที่ของสมาชิกในการรักษาข้อมูลชื่อ Login และ Password โดยไม่บอกให้ผู้อื่นทราบ
                                    <br/>(4) การกระทำการใดๆ โดยผ่านบริการ ไม่ว่ากรณีใดๆก็ตาม หากกระทำโดยใช้รหัสสมาชิกและรหัสผ่านของสมาชิกและ/หรือตรงตามวิธีการหรือเงื่อนไขที่บริษัทกำหนดไว้เกี่ยวกับการใช้บริการ EduLaw แล้ว สมาชิกตกลงให้ถือว่าการกระทำนั้นมีผลสมบูรณ์โดยสมาชิกไม่ต้องลงลายมือชื่อเป็นหลักฐานในเอกสารใดๆ อีก และยินยอมรับผิดชอบในการกระทำดังกล่าวเสมือนหนึ่งว่าสมาชิกเป็นผู้กระทำด้วยตนเอง ทั้งนี้ไม่ว่าจะเกิดขึ้นด้วยความทุจริตของบุคคลภายนอกหรือไม่ก็ตาม สมาชิกจะไม่เรียกร้องให้บริษัทต้องรับผิดชอบแต่อย่างใด
                                    <br/>(5) สมาชิกจำเป็นต้องตรวจสอบความถูกต้องในการทำรายการสั่งซื้อหนังสืออิเล็กทรอนิกส์ว่าถูกต้องหรือไม่ก่อนที่จะทำการตกลงชำระเงิน ซึ่งถ้าหากเกิดข้อผิดพลาดจากการทำรายการสั่งซื้อหนังสืออิเล็กทรอนิกส์อันเนื่องมาจากความไม่ถูกต้องของรายการเนื่องมาจากความผิดพลาดของสมาชิกเอง ทาง EduLaw จะไม่รับผิดชอบทั้งสิ้น
                                    <br/>(6) ถ้า EduLaw พบว่าสมาชิกนำหนังสืออิเล็กทรอนิกส์และตัวอย่างหนังสืออิเล็กทรอนิกส์ของ EduLaw ไปทำซ้ำ ดัดแปลง แก้ไข เผยแพร่ หรือจัดจำหน่าย โดยไม่ได้รับอนุญาตจาก EduLaw ทีมงานมีสิทธิ์ยกเลิกความเป็นสมาชิกที่ใช้บริการ EduLaw ได้โดยทันที
                                    <br/>(7) หนังสืออิเล็กทรอนิกส์ที่สมาชิกสั่งใช้บริการ ห้ามทำซ้ำหรือดัดแปลง ห้ามให้เช่าต้นฉบับหรือสำเนางาน ห้ามเผยแพร่งานต่อสาธารณชน หากผู้ใดกระทำการดังกล่าว ถือเป็นการละเมิดลิขสิทธิ์ ต้องรับโทษอาญาและจ่ายค่าเสียหายแก่เจ้าของลิขสิทธิ์และ EduLaw ด้วย หากผู้ใดรู้อยู่แล้วหรือมีเหตุอันควรรู้ว่างานใดได้ทำขึ้นโดยละเมิดลิขสิทธิ์ของผู้อื่น กระทำการต่อไปนี้แก่งานนั้นเพื่อหากำไร ให้ถือว่าผู้นั้นกระทำละเมิดลิขสิทธิ์ด้วย ได้แก่
                                    <br/>1) ขาย มีไว้เพื่อขาย เสนอขาย ให้เช่า เสนอให้เช่า ให้เช่าซื้อ หรือเสนอให้เช่าซื้อ
                                    <br/>2) เผยแพร่ต่อสาธารณชน
                                    <br/>3) แจกจ่ายในลักษณะที่อาจก่อให้เกิดความเสียหายแก่เจ้าของลิขสิทธิ์
                                    <br/>(8) สมาชิกจะต้องไม่โพสต์ข้อความที่มีเนื้อหาดังต่อไปนี้ที่ EduLaw
                                    <br/>1) ไม่โพสต์ข้อความซึ่งพาดพิงหรือลบหลู่ สถาบันพระมหากษัตริย์
                                    <br/>2) ไม่โพสต์ข้อมูลหยาบคาบ หมิ่นประมาณ หรือสร้างความเสียหายต่อบุคคลหนึ่งบุคคลใด
                                    <br/>(9) EduLaw จะไม่รับผิดชอบต่อความสูญเสียในด้านข้อมูลสมาชิก ข้อมูลการสั่งซื้อ และข้อมูลทุกๆอย่างภายในเว็บไซต์หากมีการสูญหาย จากการถูกจารกรรมความผิดพลาดจากระบบของเครื่องแม่ข่ายที่เก็บข้อมูลหรือความผิดพลาดที่เกิดจากระบบเว็บไซต์ทั้งสิ้น
                                    <br/>(10) หากพบว่าสมาชิกกระทำการที่ผิดเงื่อนไขและข้อตกลงกับ EduLaw ทีมงานมีสิทธิ์ที่จะยกเลิกความเป็นสมาชิกได้โดยทันที(3) หนังสืออิเล็กทรอนิกส์ และตัวอย่างหนังสืออิเล็กทรอนิกส์ที่ถูกจัดจำหน่ายโดย EduLaw ห้ามทำซ้ำ ดัดแปลง แก้ไข เผยแพร่ จัดจำหน่าย โดยไม่ได้รับอนุญาตจาก EduLaw</p>

            {/* <h4 style={{fontSize:150, color: 'black'}}>❝</h4>
            <h4 style={{marginTop: -70}}>พวกไม่หยุดที่จะสรรหาสินค้าที่ดีเพื่อคุณ</h4>

            <h4 style={{fontSize:150, color: 'black'}}>❝</h4>
            <h4 style={{marginTop: -70}}>พวกไม่หยุดที่จะสรรหาสินค้าที่ดีเพื่อคุณ</h4> */}

            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>

           
            

        </Container>

    );

}

export default TermsOfService;